import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import DictionaryItem from "../../../../../model/dictionary/DictionaryItem";
import DictionarySortableItemFormBody from "../DictionarySortableItemFormBody";
import DictionarySortableItemForm from "../DictionarySortableItemForm";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * Title of dictionary
	 */
	title: string
	/**
	 * On submit callback. Should call only when form is valid.
	 */
	onSubmit: (item: DictionaryItem) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Item to edit.
	 */
	item: DictionaryItem;
}

type IState = BaseFormViewState<DictionarySortableItemForm>;

export default class EditDictionarySoratbleItemFormView
	extends BaseFormView<DictionarySortableItemForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: DictionarySortableItemForm.createFromItem(this.props.item),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<DictionarySortableItemFormBody form={this.state.form}
												onFieldChange={this.onFieldChanged}
												onFieldCompleted={this.onFieldCompleted}
												onFocusChange={this.onFocusChange}
												onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={`Update ${this.props.title}`}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit, () => {});
		});
	}
}
